import { SortCategories } from 'src/app/views/sort-elements/sort-drop-down/sort-drop-down.helpers';
import { INITIAL_PAGINATION, ListMode, ListState } from '../../../shared/list-controller/list-controller';
import { RelationRequestTables } from '../../grid-table-factory/table-creator.enum';
import { RelationPageTabs, RelationRequestKnd } from '../../relation-request.enum';
import {
  FilterValue,
  PatientLink,
  RelationRequestPageTexts,
  RelationRequestsPageConfig,
} from '../../relation-request.interface';
import { RelationRequestsTables } from '../../relation-request.tokens';
import { ManageRelationRequestComponent } from '../manage-relation-request/manage-relation-request.component';
import { RelationRequestPageTabs } from '../manage-relation-request/manage-relation-request.helper';

export class PatientLinkRequestComponent extends ManageRelationRequestComponent<PatientLink, FilterValue> {}

export const PATIENT_LINK_TABLES: RelationRequestsTables = {
  [RelationPageTabs.LIST]: RelationRequestTables.PATIENT_LINKED_REQUESTS,
  [RelationPageTabs.REQUESTS_RECEIVED]: RelationRequestTables.PATIENT_RECEIVED_LINK_REQUEST,
  [RelationPageTabs.REQUESTS_SENT]: RelationRequestTables.PATIENT_SENT_LINK_REQUEST,
};

const PATIENT_LINK_PAGE_TEXTS: RelationRequestPageTexts = {
  noAcceptedRequestsHint: 'NO_ACCEPTED_PATIENT_LINKS_HINT',
  noReceivedRequestsHint: 'NO_RECEIVED_PATIENT_LINKS_HINT',
  noSentRequestsHint: 'NO_SENT_PATIENT_LINKS_HINT',
  acceptedRequestsTabTitle: 'PATIENT_LINKS_TAB_TITLE',
  searchFieldLabel: 'SEARCH_PATIENT_FIELD_LABEL',
};

const PATIENT_INITIAL_STATE: ListState<RelationRequestPageTabs, FilterValue> = {
  context: RelationPageTabs.LIST,
  pagination: INITIAL_PAGINATION,
  sorting: SortCategories.SCORE_DESC,
  filtering: '',
  mode: ListMode.BROWSE,
  queryKeyword: '',
};

export const PATIENT_PAGE_CONFIG: RelationRequestsPageConfig<FilterValue> = {
  kind: RelationRequestKnd.PATIENT_LINK,
  texts: PATIENT_LINK_PAGE_TEXTS,
  filter: null,
  initialState: PATIENT_INITIAL_STATE,
  allowedChat: false,
};
